import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import maintananceImg from '../assets/logo/maintanance-img.png';
import logo from '../assets/logo/inmate-white-logo.png';
import Button from "../../src/components/common/UI/Inputs/Button";
import "../../src/assets/css/MaintenancePage.css"
import { masterActions } from "../_store/master.slice";


const MaintenancePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginInterval = 60000; // 1min once check

  const handleUserAction = () => {
    dispatch(masterActions.GetApplicationSettings("WEB"))
      .then((result) => {
        const data = result?.payload;
        if (
          Object?.keys(data).length === 0 ||
          data?.IsApplicationMaintenance === 1
        )
          return;
        navigate("/"); window.location.reload();
      })
      .catch((err) => {
        console.error("Failed to fetch maintenance data", err);
      });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleUserAction();
    }, loginInterval);

    return () => {
      clearInterval(intervalId);
    };
  }, []);


  return (
    <div className="parent-container">
      <div>
        <div className="inmate-logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="maintance-content  shadow-sm b-r-all ">
          <div className="">
            <img src={maintananceImg} alt="Logo" className="maintance-logo img" />
          </div>
          <p className='maintance-text' >
            This website is currently undergoing maintenance and will be back
            online shortly. Thank you for your patience.
          </p>
          <div className="d-flex justify-content-center">
            <Button
              variant="primary"
              className="mt-2"
              onClick={() => { handleUserAction() }}
              label="BACK TO LOGIN"
              type="button"
              status="primary"
            />
          </div>
        </div>
        <div className="maintance-footer">
          <p>Copyright © {new Date().getFullYear()} by inmate inbox. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MaintenancePage);
